
import React from "react";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuthForm } from "@/context/AuthFormContext";

interface AuthCardProps {
  children: React.ReactNode;
}

const AuthCard = ({ children }: AuthCardProps) => {
  const { mode } = useAuthForm();

  // Helper function to render the right card title based on mode
  const getCardTitle = () => {
    switch (mode) {
      case "forgotPassword":
        return "Reset your password";
      case "resetPassword":
        return "Update your password";
      default:
        return "ReelAtlas";
    }
  };

  // Helper function to render the right card description based on mode
  const getCardDescription = () => {
    switch (mode) {
      case "forgotPassword":
        return "We'll send you a link to reset your password";
      case "resetPassword":
        return "";  // Remove description for reset password mode
      default:
        return "Chart your cinematic treasures";
    }
  };

  const cardDescription = getCardDescription();

  return (
    <Card className="w-full max-w-md bg-mono-eerieBlack border border-mono-slateGray/20 shadow-lg">
      <CardHeader className="text-center space-y-2 pt-8 pb-4">
        <CardTitle className="text-2xl font-bold tracking-tight text-mono-seasalt">
          {getCardTitle()}
        </CardTitle>
        {cardDescription && (
          <CardDescription className="text-mono-frenchGray">
            {cardDescription}
          </CardDescription>
        )}
      </CardHeader>
      
      {children}
    </Card>
  );
};

export default AuthCard;
